import { getCenter } from "reducers/tenant";

const initialAddressViewport = (center) => ({
  ...center,
  zoom: 11,
  startDragLngLat: null,
  isDragging: false,
});

export const getInitialAddressViewport = (tenant) => initialAddressViewport(getCenter(tenant));
